module.exports = __webpack_public_path__ + "static/media/no-profile-picture.ddefe7a8.png";